import React, { useState } from 'react';
import { mockData } from '../mock';

const Brands = () => {
  const [hoveredBrand, setHoveredBrand] = useState(null);

  const brandDetails = [
    {
      id: 'blue-tokai',
      name: 'Blue Tokai',
      category: 'COFFEE AT ITS BEST',
      title: 'Blue Tokai: Brewing The Future of Artisanal Coffee',
      image: '/images/brands_page_blue_tokai.png',
      logo: 'BLUE TOKAI',
      website: 'https://bluetokaicoffee.com/',
      description: 'Blue Tokai is a leading specialty coffee brand. Blue Tokai is committed to quality and sustainability. Sourcing and roasting beans to perfection, bringing an elevated coffee experience to every cup. With a strong presence in India and now growing international footprint, including Tokyo and now the GCC, Blue Tokai is shaping modern coffee culture.',
      fullDescription: 'Blue Tokai Coffee Roasters was founded with a simple vision: to make specialty coffee accessible to everyone. What started as a passion project has evolved into one of India\'s most respected coffee brands, known for its commitment to quality, sustainability, and innovation. From sourcing the finest beans directly from farmers to perfecting the roasting process, every step is meticulously crafted to deliver an exceptional coffee experience.'
    },
    {
      id: 'furn-beano',
      name: 'Furn Beaino',
      category: 'LEBANESE AND BEYOND',
      title: 'Furn Beaino: Fast Casual Food For A Good Mood',
      image: '/images/brands_page_furn.png',
      logo: 'furn beaino',
      website: 'https://furnbeaino.com/',
      description: 'Established in 1975 during the onset of Lebanon’s civil war, Furn Beaino began as a small bakery in the old souks of Jounieh. At just 20 years old, Toni Beaino set out to launch a humble yet ambitious culinary venture built on unwavering dedication to quality and consistency. Furn Beaino quickly became a household name known for its traditional lahmbaajin and manakish, later expanding to a full fast-casual menu featuring wraps, salads, pizzas, desserts, and more. ISO 22000:2005 certification and subsequently ISO 22000:2018 were attained by Furn Beaino in 2018 and 2019, respectively, which attest to the rigorous hygienic standards that its food outlets subscribe to. More recently, Furn Beaino captured the coveted FSSC 22000 certification in food safety management systems.',
      fullDescription: 'The company has identified four pillars that govern its excellence at the product and service levels. These are Quality, Consistency, Passion, and Pride. In fact, these four pillars have come to represent the four lines of the Furn Beaino logo.'
    },
    {
      id: 'biryani-by-kilo',
      name: 'Biryani by Kilo',
      category: 'MEET THE BIRYANI EXPERTS',
      title: 'Biryani by Kilo: Experience Fresh Dum-Cooked Biryani',
      image: '/images/brands_page_bbk.png',
      logo: 'BBK BIRYANI BY KILO',
      website: 'https://biryanibykilo.ae/',
      description: 'Biryani by Kilo (BBK) is a renowned Indian biryani brand celebrated for its authentic, slow-cooked Dum-style biryani. Made fresh on-site and served in traditional handis, BBK has built a loyal following across India with over 100 outlets. Now in the UAE with its first outlet in Dubai, BBK brings its rich flavors and consistent quality to biryani lovers.',
      fullDescription: 'We believe in the traditional dum cooking style. It entails simultaneous, slow-cooking of rice and marinated meat/vegetables in a sealed container over a low flame. This slow and steady cooking process ensures that the flavors of the ingredients are completely absorbed, resulting in an aromatic and flavorful biryani that melts in the mouth.'
    },
    {
      id: 'mr-brown',
      name: 'Mr. Brown',
      category: 'YOUR FAVOURITE BRAND HAS LANDED IN UAE',
      title: 'Mr. Brown: Your Friendly Next-Door Diner',
      image: '/images/brands_page_brown.jpg',
      logo: 'MR. BROWN',
      website: 'https://www.instagram.com/mrbrownuae',
      description: 'Since opening its doors in Lebanon in 2002, Mr. Brown has grown into a beloved homegrown brand and a market leader in its category. Built on the spirit of the classic American diner, Mr. Brown blends hearty comfort food with a warm, neighborhood feel—serving everything from signature burgers, submarines, and pizzas to pancakes, fresh salads, and a dedicated healthy menu crafted for lighter, low-calorie choices. What began as a simple passion for great food and genuine hospitality has evolved into a trusted destination where families, friends, and communities come together. Whether dining in or ordering from home, every meal reflects Mr. Brown’s commitment to quality, consistency, and the timeless joy of American flavors.',
      fullDescription: 'Today, Mr. Brown proudly operates four bustling locations across Lebanon, each designed to deliver the same friendly, relaxed, and approachable experience that made the brand a local favorite. In the last three years, Mr. Brown has expanded beyond Lebanon, successfully launching two branches in the UAE and solidifying its reputation as a rising international brand. With growing demand for its American-style food and accessible, friendly dining experience, Mr. Brown is now accelerating its expansion across the GCC, bringing its signature flavors to new communities across the region.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="py-12" style={{backgroundColor: '#73030D'}}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center min-h-[400px]">
            <div className="text-left">
              <p className="text-red-200 font-semibold uppercase tracking-wide mb-2">
                OUR BRANDS
              </p>
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
                Food is at the heart of what we do!
              </h1>
              <p className="text-white/90 text-base leading-relaxed">
                We believe that great food is about more than just taste; it's about uncompromising quality, consistency, and a memorable experience in every single serving.
              </p>
            </div>
            <div className="relative h-full">
              <img
                src="/images/biryani_image.png"
                alt="Biryani"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          </div>
        </div>
        
        {/* Pizza image in hero */}
        
      </div>

      {/* Brands Section */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        {brandDetails.map((brand, index) => (
          <div key={brand.id} className="mb-16 last:mb-0">
            <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
              index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''
            }`}>
              {/* Image */}
              <div 
                className={`relative h-80 rounded-2xl overflow-hidden shadow-xl cursor-pointer ${
                  index % 2 === 1 ? 'lg:col-start-2' : ''
                }`}
                onMouseEnter={() => setHoveredBrand(brand.id)}
                onMouseLeave={() => setHoveredBrand(null)}
              >
                <img
                  src={brand.image}
                  alt={brand.title}
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                />
                {/* Logo overlay on hover */}
                {hoveredBrand === brand.id && (
                  <div className="absolute inset-0 bg-black/50 flex items-center justify-center transition-opacity duration-300">
                    <div className="text-center text-white p-8">
                      <div className="text-2xl font-bold mb-2">
                        {brand.logo}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Content */}
              <div className={index % 2 === 1 ? 'lg:col-start-1 lg:row-start-1' : ''}>
                <p className="text-orange-600 font-semibold uppercase tracking-wide mb-3">
                  {brand.category}
                </p>
                <h2 className="text-3xl font-bold text-gray-900 mb-6 leading-tight">
                  {brand.title}
                </h2>
                <p className="text-gray-600 leading-relaxed mb-6">
                  {brand.description}
                </p>
                <p className="text-gray-600 leading-relaxed mb-8">
                  {brand.fullDescription}
                </p>
                <a 
                  href={brand.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-orange-600 text-white px-8 py-3 rounded-lg hover:bg-orange-700 transition-colors duration-200 font-semibold"
                >
                  READ MORE
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Brands;